import React from 'react';
import { Wheel as RouWheel } from 'react-custom-roulette';
import CustomWheelFrame from '../customWheel/CustomWheelFrame';
import './SpinWheelModal.css';

const SpinWheelModal = ({
    isOpen,
    playerName,
    isLoading,
    mustSpin,
    prizeNumber,
    data,
    onStopSpinning,
    wheelProps,
}) => {
    if (!isOpen) return null;

    return (
        <div className="spin-wheel-overlay">
            <div className="spin-wheel-content">
                <p className="spin-wheel-player">
                    Người quay: <strong>{playerName}</strong>
                </p>

                {isLoading ? (
                    <div className="spin-wheel-loading">
                        <div className="spin-wheel-loading-spinner" />
                        <p>Đang chuẩn bị vòng quay...</p>
                    </div>
                ) : (
                    data?.length > 0 && (
                        <CustomWheelFrame size="tv">
                            <RouWheel
                                mustStartSpinning={mustSpin}
                                prizeNumber={prizeNumber || 0}
                                data={data}
                                onStopSpinning={onStopSpinning}
                                {...wheelProps}
                            />
                        </CustomWheelFrame>
                    )
                )}

                {!isLoading && mustSpin && (
                    <p className="spin-wheel-status">Đang quay...</p>
                )}
            </div>
        </div>
    );
};

export default SpinWheelModal;
